import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAuthenticate, IJwtToken } from '../api/authenticate';
import { HttpHandlerService } from '../../../services/http-handler.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { CryptoService } from '../../../services/crypto.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userTokenKey = 'UserDetails';

  constructor(private router: Router, private http: HttpHandlerService, private cryptoService: CryptoService) { }

  login(username: string, password: string, rememberMe: boolean): Observable<IAuthenticate> {
    const encryptedUsername = this.encryptData(username);
    const encryptedPassword = this.encryptData(password);

    const loginData = {
      username: encryptedUsername,
      password: encryptedPassword
    };

    return this.http.post<IAuthenticate>('User/authenticate', loginData)
      .pipe(
        tap(response => {
          localStorage.setItem(this.userTokenKey, JSON.stringify(response));

          localStorage.setItem('rememberMe', rememberMe.toString());

          if (rememberMe) {
            this.storeLoginDetails(username, password);
          } else {
            this.clearStoredCredentials();
          }

        }),
        catchError(error => {
          console.error('Login failed', error);
          return throwError(() => new Error(error.error.message));
        })
      );
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem(this.userTokenKey);

    let parsedToken: IAuthenticate | null = null;
    if (token) {
      parsedToken = JSON.parse(token) as IAuthenticate;
    }
    // Add your token validation logic here
    if (parsedToken?.jwtToken.validTo) {
      const expiryDate = new Date(parsedToken.jwtToken.validTo).getTime();
      const currentDate = new Date().getTime();
      return currentDate < expiryDate;
    }
    return false;
  }

  getToken() {
    const token = localStorage.getItem(this.userTokenKey);

    let parsedToken: IAuthenticate | null = null;
    if (token) {
      parsedToken = JSON.parse(token) as IAuthenticate;
    }
    return parsedToken?.jwtToken.accessToken;
  }

  encryptData(data: string): string {
    //return CryptoJS.AES.encrypt(data, this.secretKey).toString();
    return this.cryptoService.encryptUsingAES256(data);
  }

  storeLoginDetails(username: string, password: string) {
    const encryptedUsername = this.encryptData(username);
    const encryptedPassword = this.encryptData(password);
    localStorage.setItem('username', encryptedUsername);
    localStorage.setItem('password', encryptedPassword);
  }

  getStoredCredentials() {
    const encryptedUsername = localStorage.getItem('username');
    const encryptedPassword = localStorage.getItem('password');

    if (encryptedUsername && encryptedPassword) {
      const username = this.cryptoService.decryptUsingAES256(encryptedUsername);
      const password = this.cryptoService.decryptUsingAES256(encryptedPassword);
      return { username, password };
    }
    return null;
  }

  logout() {
    const rememberMe = localStorage.getItem('rememberMe') ?? 'false';

    if (rememberMe == 'false') {
      this.clearStoredCredentials();
    }

    localStorage.removeItem(this.userTokenKey);

    this.router.navigate(['/auth/login']);
  }

  clearStoredCredentials() {
    localStorage.removeItem('username');
    localStorage.removeItem('password');
  }

}
